<template>
  <div v-if="index <= 9">
    <div class="topevent__list__item" v-if="!isLoadingChild">
      <router-link :to="'/event/' + itemEventChild.id" class="itemstatus__new">
        <div class="itemstatus__new__banner" v-if="diffDate(itemEventChild.acf?.start_date + ' ' + itemEventChild.acf?.start_time) <= 7">
          <img src="@/assets/img/top/portal_icon.svg" alt="" />
          <div class="itemstatus__new__banner__text">NEW</div>
        </div>
        <div
          class="item__img"
          :style="{ backgroundImage: `url(${$func.formatUrl(itemEventChild.acf?.image1)})` }"
          v-if="itemEventChild.acf?.image1 || itemEventChild.acf?.title && itemEventChild.acf?.image1 != '' || itemEventChild.acf?.image1 != false"
        >
          <img :src="$func.formatUrl(itemEventChild.acf?.image1)" :alt="itemEventChild.acf?.title" />
        </div>
        <div class="item__img" 
          :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }"
          v-if="itemEventChild.acf?.image1 === '' || itemEventChild.acf?.image1 === false" > 
            <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
        </div>
        <div class="item__text">
          <ul class="item__cate" v-if="itemEventChild.acf?.genre_icon || itemEventChild.acf?.target_icon || itemEventChild.acf?.organizer_icon">
            <li v-if="itemEventChild.acf?.genre_icon">{{ itemEventChild.acf?.genre_icon }}</li>
            <li v-if="itemEventChild.acf?.target_icon">{{ itemEventChild.acf?.target_icon }}</li>
            <li v-if="itemEventChild.acf?.organizer_icon">{{ itemEventChild.acf?.organizer_icon }}</li>
          </ul>
          <span class="item__title" v-if="itemEventChild.acf?.title">{{ itemEventChild.acf?.title }}</span>
          <ul class="item__tag">
            <li v-if="itemEventChild.acf?.tag != null && itemEventChild.acf?.tag != ''" :class="itemEventChild.acf?.tag === '限定' ? 'txt_c_red' : ''">#住民限定</li>
            <li v-if="itemEventChild.acf?.paid != null && itemEventChild.acf?.paid != ''" :class="itemEventChild.acf?.paid === '有料' ? 'txt_c_red' : ''">#{{ itemEventChild.acf?.paid }}</li>
            <li v-if="['要予約', '予約可', '予約不要'].includes(itemEventChild.acf?.reserve)">#{{ itemEventChild.acf?.reserve }}</li>
          </ul>
          <span class="item__date" v-if="itemEventChild.acf?.event_start_date || itemEventChild.acf?.event_end_date">{{ formatDate(itemEventChild.acf?.event_start_date) }}({{formatWeekDay(itemEventChild.acf?.event_start_date)}})〜{{ formatDate(itemEventChild.acf?.event_end_date) }}({{formatWeekDay(itemEventChild.acf?.event_end_date)}})</span>
        </div>
      </router-link>
    </div>
    <div class="skeleton-parent" v-if="isLoadingChild">
      <div v-for="(n, index) in 6" :key="index" class="skeleton-child">
        <PuSkeleton :count="15"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CONSTANT from "../../constant.js";
import { formatDate, formatWeekDay, diffDate } from '@/utils/helper';

export default {
  name: "ItemEvent",
  props: {
    itemEventChild: {
      type: Object,
    },
    index: {
      type: Number
    },
    isLoadingChild: {
      type: Boolean
    }
  },
  data() {
    return {
      // eventList: [],
      // isLoading: true,
      urlNowRinting: CONSTANT.dataImageNowrinting,
    };
  },
  components: {
    // Fragment,
  },
  computed: {
    currentDate() {
      return moment().format("YYYY/MM/DD");
    },
  },
  methods: {
    formatDate, 
    formatWeekDay, 
    diffDate
  },
};
</script>
